var map = {
	"./az/block-1920.jpg": "93b4",
	"./be/block-1920.jpg": "71f7",
	"./en/block-1920.jpg": "2978",
	"./et/block-1920.jpg": "3cef",
	"./hy/block-1920.jpg": "62df",
	"./ka/block-1920.jpg": "ec0e",
	"./kk/block-1920.jpg": "6b49",
	"./ky/block-1920.jpg": "f2d8",
	"./lt/block-1920.jpg": "54ce",
	"./lv/block-1920.jpg": "6eba",
	"./mn/block-1920.jpg": "0e34",
	"./ru/block-1920.jpg": "da1b",
	"./uz/block-1920.jpg": "def4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36c0";